import { FoodLogModel } from 'src/app/core/model/object/foodlog-model';
import { FoodFactCreate } from './../../../core/model/api-response/persoanl-response-model';
import {
  FoodFactsModel,
  FoodFactModel,
  FoodUnitRatioModel,
  FoodModel,
} from './../../../core/model/object/diet-food-model';
import { PlansService } from 'src/app/data/repository/plans-repository/plans.service';
import { CalendarShared } from './../../general/shared/calendar-shared';
import { LoadingShared } from './../../general/shared/loading-shared';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import {
  DietMealModel,
  MealRatio,
} from './../../../core/model/object/diet-model';
import { PlanShared } from 'src/app/presentation/general/shared/plan-shared';
import { ShopService } from './../../../data/repository/shop-repository/shop.service';
import { BottomsheetShared } from './../../general/shared/bottomsheet-shared';
import { DateHelper } from 'src/app/utils/date-helper';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { DietModel } from 'src/app/core/model/object/diet-model';
import { Subscription } from 'rxjs';
import { IosBottomsheetInputModel } from '../../general/ios-bottomsheet/ios-bottomsheet.component';
import { GenerateShared } from '../../general/shared/generate-shared';
import { AddFoodLogInputModel } from 'src/app/core/model/input/food-log-input-model';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';
import { IosNewBottomsheetComponent } from '../../general/ios-new-bottomsheet/ios-new-bottomsheet.component';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';

@Component({
  selector: 'app-plan-overview',
  templateUrl: './plan-overview.component.html',
  styleUrls: ['./plan-overview.component.scss'],
})
export class PlanOverviewComponent implements OnInit, OnDestroy {
  selectedMeal: DietMealModel;
  diet: DietModel;
  currentDayMeals;
  mealRatio: MealRatio[] = [];
  fastingMealRatio: MealRatio[] = [];
  showFastingMealRatio = false;
  currentDay = 0;
  selectedDay = 0;
  title = '';
  dateTitle = '';
  isBeforeStart = false;
  todayDate: Date;
  selectedDate: number;
  cheatDayCount = 0;
  changed: boolean = false;
  isFasting = false;
  endTime = 0;
  duration = 0;
  fastingTime = 0;
  showchartY: boolean = false;
  expireDate: number;
  lockPlan = false;
  dataType = 'hourly';
  showPreviousDay = true;
  showNextDay = true;

  fakeArrayMeals = ['', '', '', '', '', ''];

  showLoading = false;
  dataIsReady = false;

  showIosBottomsheet = false;
  iosBottomsheetInput: IosBottomsheetInputModel;
  shownotif: boolean = false;
  ifshownotif = false;

  selectedMealNotif: string = '';
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;

  showFoodFactDetail: boolean = false;
  foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  constructor(
    public planService: PlanService,
    private dateHelper: DateHelper,
    private bottomsheetShared: BottomsheetShared,
    private generateShared: GenerateShared,
    private shopService: ShopService,
    private planShared: PlanShared,
    public calorieCalculator: CalorieCalculator,
    private diaryAnalytics: DiaryAnalyticsService,
    private snackBarService: SnackBarService,
    private matBottomSheet: MatBottomSheet,
    private loadingShared: LoadingShared,
    private calendarShared: CalendarShared,
    private plansService: PlansService,
    private recipeService: RecipeService
  ) {
    this.subscription1 =
      this.bottomsheetShared.closeIosBottomsheetObs$.subscribe((close) => {
        if (close) {
          this.generateShared.previousUrl = '';
          this.showIosBottomsheet = false;
        }
      });
    this.subscription2 = this.planShared.refreshDietObs$.subscribe(
      (refresh) => {
        if (refresh) {
          if (this.diet.type.type === 'daily') {
            this.getDietFromServer();
          } else {
            this.initial();
          }
        }
      }
    );
    this.subscription3 = this.planShared.refreshMyPlanObs$.subscribe(
      (refresh) => {
        if (refresh) {
          this.initial();
        }
      }
    );
    this.subscription4 =
      this.bottomsheetShared.pendingFoodsConfirmObs$.subscribe((confirm) => {
        if (confirm) {
          this.matBottomSheet.dismiss();
          this.pending();
        }
      });
    this.subscription5 = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.showFoodFactDetail = false;
        }
      }
    );
    this.initial();
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
  }

  initial() {
    this.dataIsReady = false;
    this.todayDate = new Date(new Date().setHours(0, 0, 1, 0));

    this.planService.getDayDiet().then((res) => {
      if (res.isSuccess()) {
        const diets = res.getData().getDiets();
        const day = res.getData().getDaysCount() - 1;
        this.diet = diets[0];

        this.selectedDay = day;
        this.currentDayMeals = diets[0].days[this.selectedDay].meals;
        if (diets.length !== 0) {
          let createdTime = 0;
          diets.forEach(async () => {
            if (createdTime < new Date(this.diet.createdAt).getTime()) {
              createdTime = new Date(this.diet.createdAt).getTime();
              if (this.plansService.historyPage) {
                await this.planService
                  .prepareDietDayFoods(this.diet.days[this.selectedDay])
                  .then((res) => {
                    this.plansService.historyPage = this.selectedDay;
                    this.diet.days[this.selectedDay] = res;
                  });
              } else {
                await this.planService
                  .prepareDietDayFoods(this.diet.days[0])
                  .then((res) => {
                    this.plansService.historyPage = 0;
                    this.diet.days[0] = res;
                  });
              }
              if (this.diet.type.mealRatioArray.length === 1) {
                this.mealRatio = this.diet.type.mealRatioArray[0].mealRatios;
              } else {
                if (this.diet.type.mealRatioArray[0].type === 'normal') {
                  this.mealRatio = this.diet.type.mealRatioArray[0].mealRatios;
                  this.fastingMealRatio =
                    this.diet.type.mealRatioArray[1].mealRatios;
                } else {
                  this.mealRatio = this.diet.type.mealRatioArray[1].mealRatios;
                  this.fastingMealRatio =
                    this.diet.type.mealRatioArray[0].mealRatios;
                }
              }
              let date = this.todayDate.getTime();
              if (this.diet.startDate > date) {
                this.isBeforeStart = true;
                date = new Date().setHours(0, 0, 0, 1);
                this.diet.startDate = new Date(this.diet.startDate).setHours(
                  0,
                  0,
                  0,
                  0
                );
                this.currentDay = this.calculateSelectedDay(date) + 1;
                this.selectedDay = this.plansService.historyPage
                  ? this.plansService.historyPage
                  : day;
                this.selectedDate = this.diet.startDate;
                if (this.diet.type.type === 'daily') {
                  let dayOfWeek = new Date(this.selectedDate).getDay() + 2;
                  dayOfWeek = dayOfWeek === 8 ? 1 : dayOfWeek;
                  if (this.diet.fasting.fastingDays.includes(dayOfWeek)) {
                    this.showFastingMealRatio = true;
                  } else {
                    this.showFastingMealRatio = false;
                  }
                }
                this.bottomsheetShared.startDay = this.currentDay;
                this.bottomsheetShared.selectedDietId = this.diet._id;
              } else {
                this.isBeforeStart = false;
                date = this.todayDate.getTime();
                this.diet.startDate = new Date(this.diet.startDate).setHours(
                  0,
                  0,
                  0,
                  0
                );
                this.selectedDay = this.plansService.historyPage
                  ? this.plansService.historyPage
                  : day;
                const startingDate = new Date(this.diet.startDate);
                this.selectedDate = startingDate.setDate(
                  startingDate.getDate() + this.selectedDay
                );

                if (this.diet.type.type === 'daily') {
                  this.dataType = 'daily';

                  let dayOfWeek = new Date(this.selectedDate).getDay() + 2;
                  dayOfWeek = dayOfWeek === 8 ? 1 : dayOfWeek;
                  if (this.diet.fasting.fastingDays.includes(dayOfWeek)) {
                    this.showFastingMealRatio = true;
                    this.isFasting = true;
                  } else {
                    this.showFastingMealRatio = false;
                    this.isFasting = false;
                  }
                  this.duration = this.diet.fasting.fasting;
                  console.log({ f: this.diet.fasting.fasting });
                }
                if (this.diet.type.type === 'hourly') {
                  this.dataType = 'hourly';

                  const now = new Date();
                  this.fastingTime = new Date().setHours(
                    new Date(this.diet.fasting.fastingTime).getHours(),
                    new Date(this.diet.fasting.fastingTime).getMinutes(),
                    new Date(this.diet.fasting.fastingTime).getSeconds()
                  );

                  if (this.fastingTime > now.getTime()) {
                    if (
                      this.fastingTime - now.getTime() >
                      (24 - this.diet.fasting.fasting) * (60 * 60 * 1000)
                    ) {
                      this.isFasting = true;
                      this.endTime =
                        this.diet.fasting.fastingTime +
                        this.diet.fasting.fasting * 60 * 60 * 1000;
                      this.fastingTime -= 24 * 60 * 60 * 1000;
                    } else {
                      this.isFasting = false;
                      this.endTime = this.diet.fasting.fastingTime;
                    }
                  } else {
                    if (
                      now.getTime() - this.fastingTime >
                      this.diet.fasting.fasting * (60 * 60 * 1000)
                    ) {
                      this.isFasting = false;
                      this.endTime = this.diet.fasting.fastingTime;
                      this.fastingTime += 24 * 60 * 60 * 1000;
                    } else {
                      this.isFasting = true;
                      this.endTime =
                        this.diet.fasting.fastingTime +
                        this.diet.fasting.fasting * 60 * 60 * 1000;
                    }
                  }
                  this.duration = this.isFasting
                    ? this.diet.fasting.fasting
                    : 24 - this.diet.fasting.fasting;
                  console.log({ f: this.duration });

                  this.showchartY = true;
                  this.changed = false;
                  this.changed = true;
                }
              }
              this.diet.days.forEach((day) => {
                if (day.isCheatDay) {
                  this.cheatDayCount++;
                }
              });
              await this.getPlanSubscription();
              this.title = this.diet.type
                ? this.diet.type.name
                : 'رژیم شخصی سازی شده';
              let startDate = new Date(this.diet.startDate);
              startDate = new Date(
                startDate.setDate(startDate.getDate() + this.selectedDay)
              );
              this.dateTitle =
                this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(
                  startDate
                );
              this.checkButtonsActivation();
              await this.planService
                .prepareDietDayFoods(this.diet.days[this.selectedDay])
                .then((res) => {
                  this.plansService.historyPage = this.selectedDay;
                  this.diet.days[this.selectedDay] = res;
                });
              this.dataIsReady = true;
            }
            this.changed = false;
            this.changed = true;
          });
          console.log(this.diet);
        } else {
          this.diet = null;
          this.dataIsReady = true;
          // this.back();
        }
      } else {
        this.diet = null;
        this.dataIsReady = true;
        // this.back();
      }
    });
  }
  goToRecipe(id: string) {
    this.recipeService.goToRecipeDetail(id);
  }
  async getDietFromServer() {
    const res = await this.planService.getDietListAndRefreshDB();
    if (res.isSuccess()) {
      this.initial();
      this.planShared.refreshDietDay();
    }
  }

  async getPlanSubscription(): Promise<boolean> {
    const result = await this.shopService.getPlanSubscription(false);
    if (result.isSuccess()) {
      this.expireDate = result.getData().getPlanSubscription().expireDate;
      this.checkPlanSubscription();
    }
    return Promise.resolve(true);
  }

  checkPlanSubscription() {
    const diffTime = this.expireDate - this.selectedDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    this.lockPlan = diffDays < 0 ? true : false;
  }

  setting() {
    this.iosBottomsheetInput = new IosBottomsheetInputModel(
      ['بله'],
      'خیر',
      'آیا میخواهید برنامه غذایی خود را پیش از موعد به پایان برسانید؟'
    );
    this.generateShared.previousUrl = 'planOverview';
    this.showIosBottomsheet = true;
  }

  nextDay() {
    if (this.diet.days.length - 1 > this.selectedDay) {
      this.dataIsReady = false;

      this.selectedDay++;

      this.plansService.setDay(this.selectedDay.toString());
      const startDate = new Date(this.diet.startDate);
      this.selectedDate = startDate.setDate(
        startDate.getDate() + this.selectedDay
      );
      this.dateTitle = this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(
        new Date(this.selectedDate)
      );
      if (this.diet.type.type === 'daily') {
        let dayOfWeek = new Date(this.selectedDate).getDay() + 2;
        dayOfWeek = dayOfWeek === 8 ? 1 : dayOfWeek;
        if (this.diet.fasting.fastingDays.includes(dayOfWeek)) {
          this.showFastingMealRatio = true;
        } else {
          this.showFastingMealRatio = false;
        }
      }
      this.planService
        .prepareDietDayFoods(this.diet.days[this.selectedDay])
        .then((res) => {
          this.plansService.historyPage = this.selectedDay;
          this.diet.days[this.selectedDay] = res;
          this.dataIsReady = true;
        });
      this.checkPlanSubscription();
      this.changed = false;
      this.changed = true;
    }
    this.checkButtonsActivation();
  }

  previousDay() {
    if (this.selectedDay > 0) {
      this.dataIsReady = false;

      this.selectedDay--;
      this.plansService.setDay(this.selectedDay.toString());

      const startDate = new Date(this.diet.startDate);
      this.selectedDate = startDate.setDate(
        startDate.getDate() + this.selectedDay
      );
      this.dateTitle = this.dateHelper.getTodayYesterdayTomorrowOrMonthAndDay(
        new Date(this.selectedDate)
      );
      if (this.diet.type.type === 'daily') {
        let dayOfWeek = new Date(this.selectedDate).getDay() + 2;
        dayOfWeek = dayOfWeek === 8 ? 1 : dayOfWeek;
        if (this.diet.fasting.fastingDays.includes(dayOfWeek)) {
          this.showFastingMealRatio = true;
        } else {
          this.showFastingMealRatio = false;
        }
      }
      this.planService
        .prepareDietDayFoods(this.diet.days[this.selectedDay])
        .then((res) => {
          this.plansService.historyPage = this.selectedDay;
          this.diet.days[this.selectedDay] = res;
          this.dataIsReady = true;
        });
      this.checkPlanSubscription();
      this.changed = false;
      this.changed = true;
    }
    this.checkButtonsActivation();
  }

  goToShop() {
    this.shopService.goToShopPage('planOverview');
  }

  goToCheatDay() {
    this.planService.goToCheatDay(
      this.diet._id,
      this.selectedDay.toString(),
      true,
      this.cheatDayCount,
      !this.diet.type.isPersonal && !this.diet.type.fasting
    );
  }

  consumed(meal: DietMealModel) {
    this.loadingShared.showLoading();
    setTimeout(() => {
      this.planService
        .changeStatus(
          this.diet._id,
          this.selectedDay.toString(),
          meal.meal,
          'consumed',
          false
        )
        .then(async (res) => {
          if (res.isSuccess()) {
            this.diaryAnalytics.analyticDiaryPackageStatusChanged(
              'consumed',
              this.selectedDay.toString()
            );
            meal.status = 'consumed';
            let foodlogList = [];
            let date = new Date(this.selectedDate);
            date = new Date(date.setHours(0, 0, 1, 0));
            meal.foods.forEach((food) => {
              foodlogList.push(
                new AddFoodLogInputModel(
                  date.getTime(),
                  food.amount,
                  food.food,
                  meal.meal,
                  food.foodModel.primaryFoodUnit,
                  meal._id
                )
              );
            });
            const result = await this.planService.addFood(foodlogList, true);
            if (result.isSuccess()) {
              if (
                this.dateHelper.isSameDay(
                  this.calendarShared.selectedDate,
                  date
                )
              ) {
                this.planShared.refreshDietDay();
              }

              this.ifshownotif = true;
              setTimeout(() => {
                this.shownotif = true;
              }, 100);
              this.selectedMealNotif = meal.meal;
              setTimeout(() => {
                this.shownotif = false;
              }, 3000);
              setTimeout(() => {
                this.ifshownotif = false;
              }, 3500);
            }
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    }, 100);
  }

  pendingDialog(meal: DietMealModel) {
    this.selectedMeal = meal;
    this.matBottomSheet.open(IosNewBottomsheetComponent, {
      panelClass: 'custom-ios-bottomsheet-container',
      data: {
        actionButtonTitles: ['بله'],
        dismissTitle: 'خیر',
        title: 'آیا از خوردن این پکیج صرف نظر کردید؟',
        type: 'pending',
      },
    });
  }

  pending() {
    this.loadingShared.showLoading();
    setTimeout(() => {
      this.planService
        .changeStatus(
          this.diet._id,
          this.selectedDay.toString(),
          this.selectedMeal.meal,
          'pending',
          false
        )
        .then(async (res) => {
          if (res.isSuccess()) {
            this.diaryAnalytics.analyticDiaryPackageStatusChanged(
              'pending',
              this.selectedDay.toString()
            );
            this.selectedMeal.status = 'pending';
            let foodLogIds = [];
            let date = new Date(this.selectedDate);
            date = new Date(date.setHours(0, 0, 1, 0));
            this.planService
              .getThisDayFoodLogs(date.getTime(), false, true)
              .then(async (res) => {
                for (const food of this.selectedMeal.foods) {
                  for (const foodLog of res) {
                    if (food.food === foodLog.food) {
                      foodLogIds.push(foodLog._id);
                    }
                  }
                }
                const result = await this.planService.removeFood(
                  date.getTime(),
                  foodLogIds,
                  false
                );
                if (result.isSuccess()) {
                  if (
                    this.dateHelper.isSameDay(
                      this.calendarShared.selectedDate,
                      date
                    )
                  ) {
                    this.planShared.refreshDietDay();
                  }
                }
                this.loadingShared.hideLoading();
              });
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
            this.loadingShared.hideLoading();
          }
        });
    }, 100);
  }

  changeStartDay() {
    this.bottomsheetShared.bottomsheetType = 'startDay';
    this.bottomsheetShared.openBottomsheet();
  }

  changeTab() {
    this.planShared.showFirstTab();
  }

  changePackage(meal: string) {
    this.plansService.openBottomSheet(
      meal,
      this.diet._id,
      this.selectedDay.toString()
    );

    // this.planService.goToChangeMeal(
    //   this.diet._id,
    //   (this.selectedDay).toString(),
    //   meal
    // );
  }

  checkButtonsActivation() {
    if (this.selectedDay === 0) {
      this.showPreviousDay = false;
    } else {
      this.showPreviousDay = true;
    }
    if (this.selectedDay === this.diet.days.length - 1) {
      this.showNextDay = false;
    } else {
      this.showNextDay = true;
    }
  }

  calculateSelectedDay(date: number): number {
    return this.dateHelper.calculateDays(this.diet.startDate, date);
  }

  findMealName(m: string): string {
    if (this.showFastingMealRatio) {
      return this.fastingMealRatio.find(({ meal }) => meal === m).meal_text;
    }
    return this.mealRatio.find(({ meal }) => meal === m).meal_text;
  }
  openChart(s: DietMealModel) {
    let res;
    let selectedFood;
    const d = s.foods.map((v, i) => {
      const ratio = this.calorieCalculator.findFoodRatio(v);
      const foodModel = new FoodModel(
        v._id,
        v.foodModel.name,
        v.foodModel.primaryFoodUnit,
        v.foodModel.foodFact.calorieAmount,
        v.foodModel.foodUnitRatioArray,
        v.foodModel.foodFact,
        this.makeFoodFactsModel(v.foodModel.foodFact)
      );
      selectedFood = new FoodLogModel(
        v.amount,
        0,
        v.foodModel._id,
        '',
        v.foodModel.primaryFoodUnit,
        '',
        foodModel,
        v._id
      );
      res = this.prepareFoodFactsAmounts(
        selectedFood,
        this.foodFactsAmount,
        ratio
      );
      res[0] = this.calorieCalculator.calculateMealCalorie(s);
      res = res.map((v) => parseFloat((v as number).toFixed(1)));
    });

    this.bottomsheetShared.selectedFoodFactsAmounts = res;
    this.bottomsheetShared.selectedFoodFactsNames =
      this.prepareFoodFactsPersianNames(selectedFood);
    this.bottomsheetShared.selectedFoodFactsUnits =
      this.prepareFoodFactsPersianUnits(selectedFood);
    this.showFoodFactDetail = true;
    this.bottomsheetShared.openFoodFactBottomsheet();
  }

  prepareFoodFactsAmounts(
    food: FoodLogModel,
    foodFactsAmount: number[],
    ratio: FoodUnitRatioModel
  ): number[] {
    if (food.calorie && food.title) {
      foodFactsAmount[0] = food.calorie + foodFactsAmount[0];
    } else {
      foodFactsAmount[0] =
        food.foodModel.foodFactModel.calorie.amount !== -1 &&
        this.foodFactsAmount[0] !== -1
          ? ((food.foodModel.foodFactModel.calorie.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[0]
          : 0;
      foodFactsAmount[1] =
        food.foodModel.foodFactModel.protein.amount !== -1 &&
        this.foodFactsAmount[1] !== -1
          ? ((food.foodModel.foodFactModel.protein.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[1]
          : 0;
      foodFactsAmount[2] =
        food.foodModel.foodFactModel.carbohydrate.amount !== -1 &&
        this.foodFactsAmount[2] !== -1
          ? ((food.foodModel.foodFactModel.carbohydrate.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[2]
          : 0;
      foodFactsAmount[3] =
        food.foodModel.foodFactModel.fat.amount !== -1 &&
        this.foodFactsAmount[3] !== -1
          ? ((food.foodModel.foodFactModel.fat.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[3]
          : 0;
      foodFactsAmount[4] =
        food.foodModel.foodFactModel.sugar.amount !== -1 &&
        this.foodFactsAmount[4] !== -1
          ? ((food.foodModel.foodFactModel.sugar.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[4]
          : 0;
      foodFactsAmount[5] =
        food.foodModel.foodFactModel.fiber.amount !== -1 &&
        this.foodFactsAmount[5] !== -1
          ? ((food.foodModel.foodFactModel.fiber.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[5]
          : 0;
      foodFactsAmount[6] =
        food.foodModel.foodFactModel.sodium.amount !== -1 &&
        this.foodFactsAmount[6] !== -1
          ? ((food.foodModel.foodFactModel.sodium.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[6]
          : 0;
      foodFactsAmount[7] =
        food.foodModel.foodFactModel.potassium.amount !== -1 &&
        this.foodFactsAmount[7] !== -1
          ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[7]
          : 0;
      foodFactsAmount[8] =
        food.foodModel.foodFactModel.calcium.amount !== -1 &&
        this.foodFactsAmount[8] !== -1
          ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[8]
          : 0;
      foodFactsAmount[9] =
        food.foodModel.foodFactModel.magnesium.amount !== -1 &&
        this.foodFactsAmount[9] !== -1
          ? ((food.foodModel.foodFactModel.magnesium.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[9]
          : 0;
      foodFactsAmount[10] =
        food.foodModel.foodFactModel.phosphor.amount !== -1 &&
        this.foodFactsAmount[10] !== -1
          ? ((food.foodModel.foodFactModel.phosphor.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[10]
          : 0;
      foodFactsAmount[11] =
        food.foodModel.foodFactModel.iron.amount !== -1 &&
        this.foodFactsAmount[11] !== -1
          ? ((food.foodModel.foodFactModel.iron.amount * food.amount) / 100) *
              ratio.ratio +
            foodFactsAmount[11]
          : 0;
      foodFactsAmount[12] =
        food.foodModel.foodFactModel.saturatedFat.amount !== -1 &&
        this.foodFactsAmount[12] !== -1
          ? ((food.foodModel.foodFactModel.saturatedFat.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[12]
          : 0;
      foodFactsAmount[13] =
        food.foodModel.foodFactModel.monounsaturatedFat.amount !== -1 &&
        this.foodFactsAmount[13] !== -1
          ? ((food.foodModel.foodFactModel.monounsaturatedFat.amount *
              food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[13]
          : 0;
      foodFactsAmount[14] =
        food.foodModel.foodFactModel.polyunsaturatedFat.amount !== -1 &&
        this.foodFactsAmount[14] !== -1
          ? ((food.foodModel.foodFactModel.polyunsaturatedFat.amount *
              food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[14]
          : 0;
      foodFactsAmount[15] =
        food.foodModel.foodFactModel.transFat.amount !== -1 &&
        this.foodFactsAmount[15] !== -1
          ? ((food.foodModel.foodFactModel.transFat.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[15]
          : 0;
      foodFactsAmount[16] =
        food.foodModel.foodFactModel.cholesterol.amount !== -1 &&
        this.foodFactsAmount[16] !== -1
          ? ((food.foodModel.foodFactModel.cholesterol.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[16]
          : 0;
    }
    foodFactsAmount.map((v, i) => {
      if (v === v && v % 1 !== 0) foodFactsAmount[i] = Number(v.toFixed(1));
    });
    return foodFactsAmount;
  }
  prepareFoodFactsPersianNames(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }

  prepareFoodFactsPersianUnits(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }
  makeFoodFactsModel(f: FoodFactCreate): FoodFactsModel {
    const calorie = new FoodFactModel('calorie', f.calorieAmount);
    const protein = new FoodFactModel('protein', f.proteinAmount);
    const fat = new FoodFactModel('fat', f.fatAmount);
    const carbohydrat = new FoodFactModel('carbohydrate', f.carbohydrateAmount);
    const sugar = new FoodFactModel('sugar', f.sugarAmount);
    const fiber = new FoodFactModel('fiber', f.fiberAmount);
    const sodium = new FoodFactModel('sodium', f.sodiumAmount);
    const potassium = new FoodFactModel('potassium', f.potassiumAmount);
    const calcium = new FoodFactModel('calcium', f.calciumAmount);
    const magnesium = new FoodFactModel('magnesium', f.magnesiumAmount);
    const iron = new FoodFactModel('iron', f.ironAmount);
    const cholesterol = new FoodFactModel('cholesterol', f.cholesterolAmount);
    const phosphor = new FoodFactModel('phosphor', f.phosphorAmount);
    const saturatedFat = new FoodFactModel(
      'saturatedFat',
      f.saturatedFatAmount
    );
    const polyunsaturatedFat = new FoodFactModel(
      'polyunsaturatedFat',
      f.polyunsaturatedFatAmount
    );
    const transFat = new FoodFactModel('transFat', f.transFatAmount);
    const monounsaturatedFat = new FoodFactModel(
      'monounsaturatedFat',
      f.monounsaturatedFatAmount
    );
    return new FoodFactsModel(
      calorie,
      protein,
      fat,
      carbohydrat,
      sugar,
      fiber,
      sodium,
      potassium,
      calcium,
      magnesium,
      iron,
      cholesterol,
      phosphor,
      saturatedFat,
      polyunsaturatedFat,
      transFat,
      monounsaturatedFat
    );
  }
}
